<template>
    <section>
        <p class="d-none d-md-block text--secondary font-italic pl-3">
            <span v-if="goodPractices.length > 1">{{ goodPractices.length }} good practices gevonden</span>
            <span v-else-if="goodPractices.length <= 0">Geen good practices gevonden</span>
            <span v-else>Eén good practice gevonden</span>
        </p>
        <ul class="list-unstyled">
            <li v-for="goodPractice in paginatedGoodPractices" :key="goodPractice.uuid" class="mb-4">
                <GoodPracticeCard :good-practice="goodPractice"></GoodPracticeCard>
            </li>
        </ul>
        <v-pagination
            v-if="pageLength > 1"
            v-model="page"
            :length="pageLength"
            circle
            prev-icon="fal fa-angle-left"
            next-icon="fal fa-angle-right"
            :total-visible="($vuetify.breakpoint.mdAndDown) ? 5 : 10"
            class="mt-7"
        ></v-pagination>
    </section>
</template>

<script>
import {mapState} from "vuex";
import GoodPracticeCard from "./GoodPracticeCard";

export default {
    name: "GoodPracticeList",
    components: {GoodPracticeCard},
    props: {
        itemsPerPage: {
            type: Number,
            default: 5,
        },
    },
    computed: {
        paginatedGoodPractices() {
            const offset = (this.page - 1) * this.itemsPerPage;
            return this.goodPractices.slice(offset, offset + this.itemsPerPage);
        },
        page: {
            get() { return this.goodPracticePage; },
            set(value) { this.$store.dispatch('goodPractice/updateGoodPracticePage', value); }
        },
        pageLength() {
            return Math.ceil(this.goodPractices.length / this.itemsPerPage);
        },
        ...mapState({
            goodPractices: state => state.goodPractice.goodPractices,
            goodPracticePage: state => state.goodPractice.goodPracticePage,
        }),
    },
}
</script>
